import UpdatePurchaseReturn from "../../../../components/@documents/purchase_returns/UpdatePurchaseReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseReturnUpdatePage() {

    return (
        <UpdatePurchaseReturn 
            routeType={routeTypes.admin}
        />
    )
}